import * as React from 'react';
import OpenedSvg from '../images/opened';
import ClosedSvg from '../images/closed';
import config from '../../../config';
import Link from '../link';
import * as Unicons from '@iconscout/react-unicons';

const TreeNode = ({
  className = '',
  setCollapsed,
  collapsed,
  url,
  title,
  items,
  Icon,
  name,
  ...rest
}) => {
  const isCollapsed = collapsed[url];

  const collapse = () => {
    setCollapsed(url);
  };

  const hasChildren = items?.length !== 0;

  let location;

  if (typeof document != 'undefined') {
    location = document.location;
  }
  const active =
    location && (location.pathname === url || location.pathname === config.gatsby.pathPrefix + url);

  const calculatedClassName = `${className} item ${active ? 'active' : ''}`;

  const Icons = {
    Home: Unicons.UilEstate,
    'Getting Started': Unicons.UilPlay,
    'Data Ingestion & CRUD': Unicons.UilFolderOpen,
    Authentication: Unicons.UilShieldCheck,
    Search: Unicons.UilSearch,
    Chat: Unicons.UilRobot,
    'Auto Complete': Unicons.UilCheckCircle,
    Analytics: Unicons.UilAnalysis,
  };

  items = items.map((item) => {
    let name = item?.title ? item?.title : 'Home';
    return {
      ...item,
      Icon: Icons[name] || Icons.Home,
    };
  });

  return (
    <li className={calculatedClassName}>
      {title && (
        <Link to={url}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Icon
              size={15}
              style={{
                marginRight: '10px', // needed for visual alignment
              }}
            />
            <div>{title}</div>
          </div>
          {!config.sidebar.frontLine && title && hasChildren ? (
            <button onClick={collapse} aria-label="collapse" className="collapser">
              {!isCollapsed ? <OpenedSvg /> : <ClosedSvg />}
            </button>
          ) : null}
        </Link>
      )}

      {!isCollapsed && hasChildren ? (
        <ul>
          {items?.map((item, index) => (
            <TreeNode
              key={item.url + index.toString()}
              setCollapsed={setCollapsed}
              collapsed={collapsed}
              {...item}
            />
          ))}
        </ul>
      ) : null}
    </li>
  );
};

export default TreeNode;
